import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { AccordionItem } from './ui/AccordionItem';
export function EbookIndex() {
  const modules = [{
    title: 'Módulo 1: Fundamentos de Amazon FBA',
    content: 'Qué es FBA, cómo funciona el ecosistema, tipos de vendedores y por qué Amazon.com (USA) es el marketplace más atractivo.'
  }, {
    title: 'Módulo 2: Vender desde otros países',
    content: 'Requisitos legales, cómo abrir cuenta desde LatAm/España, opciones de cobro (Payoneer, Wise), logística internacional y consideraciones fiscales básicas.'
  }, {
    title: 'Módulo 3: Configurar Seller Central',
    content: 'Paso a paso para abrir tu cuenta, elegir plan Individual vs Professional, configurar pagos, impuestos y shipping settings.'
  }, {
    title: 'Módulo 4: Modelos de negocio',
    content: 'Private Label, Wholesale, Online Arbitrage, Retail Arbitrage, Bundles y Handmade. Comparativa con capital mínimo, riesgo y escalabilidad.'
  }, {
    title: 'Módulo 5: Investigación de producto',
    content: 'Criterios de selección, herramientas gratuitas y de pago, análisis de demanda, competencia y cálculo de viabilidad.'
  }, {
    title: 'Módulo 6: Proveedores',
    content: 'Alibaba, ferias, distribuidores locales. Cómo contactar, negociar, pedir muestras y detectar red flags.'
  }, {
    title: 'Módulo 7: Costos y tarifas de Amazon',
    content: 'Referral fees, FBA fees, storage fees, publicidad. Cómo armar tu P&L por producto. Nota: las tarifas se actualizan; siempre verificar en Seller Central.'
  }, {
    title: 'Módulo 8: Crear un listing que convierte',
    content: 'Título, bullets, descripción, backend keywords, fotografía de producto y A+ Content básico.'
  }, {
    title: 'Módulo 9: Lanzamiento y operación',
    content: 'Estrategia de lanzamiento, PPC básico, gestión de inventario, reposición y SOP semanal del vendedor.'
  }, {
    title: 'Módulo 10: Plan de 30 días + Checklists',
    content: "Calendario de acciones día por día, checklists de validación, plantillas de P&L y lista de Do & Don't."
  }];
  return <SectionWrapper data-id="element-110">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-111">
        <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-112">
          Índice completo del ebook
        </h2>
        <p className="text-lg text-slate-600" data-id="element-113">
          Más de 60 páginas organizadas en módulos prácticos
        </p>
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 px-6 md:px-8 py-4" data-id="element-114">
        {modules.map((module, index) => <AccordionItem key={index} title={module.title} data-id="element-115">
            {module.content}
          </AccordionItem>)}
      </div>
    </SectionWrapper>;
}